module.exports = __webpack_public_path__ + "static/jj.d15871e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jj.jpg
// module id = 582
// module chunks = 35783957827783